import { RenameAccountFormComponent } from './rename-account-form/rename-account-form.component';
import { SharedModule } from './../../shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RenameYourAccountComponent } from './rename-your-account.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RenameYourAccountService } from './rename-your-account.service';
import { SummaryComponent } from './summary/summary.component';

@NgModule({
	imports: [
		CommonModule,
		SharedModule,
		FormsModule,
		ReactiveFormsModule
	],
	declarations: [
		RenameYourAccountComponent,
		RenameAccountFormComponent,
		SummaryComponent
	],
	providers: [RenameYourAccountService]
})
export class RenameYourAccountModule { }



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/rename-your-account/rename-your-account.module.ts